import { render, staticRenderFns } from "./AddOperationPromote.vue?vue&type=template&id=480bfdf4&scoped=true&"
import script from "./AddOperationPromote.vue?vue&type=script&lang=js&"
export * from "./AddOperationPromote.vue?vue&type=script&lang=js&"
import style0 from "./AddOperationPromote.vue?vue&type=style&index=0&id=480bfdf4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480bfdf4",
  null
  
)

export default component.exports